
(function(template){
define('vue!modeSelector/components/GuestSelectComponent',['Vue','vuex','vue!./LoginComponent','vue!./GroupMemberListComponent'],function(Vue,vuex,LoginComponent,GroupMemberListComponent){
    return {
        name: 'Login-Segment',
        template: template,
        components: {
            'login-component' : LoginComponent,
            'group-member-list-component' : GroupMemberListComponent
        },
        data: function(){
            return {
                showLoginComponent: false,
                userLoggedIn: false
            }
        },
        mounted: function(){
            if(app.data.CustomerGUID && app.data.CustomerId) this.userLoggedIn = true;
        }
    }
})
})('<div class="accordion-group segment bookingModeHeaders " tabindex="-1"> <div class="accordion-heading" tabindex="-1"> <a aria-expanded="false" aria-controls="accordion-body" class="accordion-toggle collapsed segment-header" data-toggle="collapse" href="\'#accordion-body" tabindex=\'0\'> {{localization.spaBooking.packageBooking.modeSelector.groupBookingText}} </a> </div> <div role="region" :aria-label="localization.spaBooking.packageBooking.modeSelector.groupBookingText" id="accordion-body" class="accordion-body collapse " style="height: 0px; display: none;"> <div class="accordion-inner"> <login-component :userLoggedIn.sync="userLoggedIn" v-if="!userLoggedIn" ></login-component> <group-member-list-component v-else ></group-member-list-component> </div> </div> </div>');
